
export default class VekKtg {

    static getNazevVekoveKategorie(vekKtg: string) {
        switch (vekKtg) {
            case "D1": return "Děti I";
            case "D2": return "Děti II";
            case "J1": return "Junioři I";
            case "J2": return "Junioři II";
            case "JU": return "Junioři";
            case "ML": return "Mládež";
            case "DS": return "Dospělí";
            case "SE": return "Senioři";
            case "S1": return "Senioři I";
            case "S2": return "Senioři II";
            case "S3": return "Senioři III";
            case "S4": return "Senioři IV";
            case "21": return "Do 21";
            case "U8": return "Do 8";
        }
    }


    static getVek = (vekKtg1: string, vekKtg2: string) => {
        let result = VekKtg.getNazevVekoveKategorie(vekKtg1);
        if (vekKtg1 !== vekKtg2) {
            result += (' (příští rok ' + VekKtg.getNazevVekoveKategorie(vekKtg2)) + ')';
        }
        return result;
    }
}